<div mat-dialog-title>Observera</div>
<div class="dialog-container">

  <div>
    <p>
      Du har markerat "Nyttjat till slutfinansiering". Om du sparar kommer automatisk
      gallring att ske.
    </p>

    <p class="important-notice">
      OBS! Åtgärden kan inte ångras
    </p>

    <p>
      Är du säker på att du vill gå vidare?
    </p>
  </div>

  <mat-dialog-actions align="end">
    <button matButton="outlined" matDialogClose>Avbryt</button>
    <button [matDialogClose]="true" matButton="filled">
      Ja
    </button>
  </mat-dialog-actions>
</div>